//painel-admin/src/pages/TikpagBI.jsx

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "../axiosConfig";
import {
  Activity,
  CheckCircle2,
  Database,
  RefreshCcw,
  ServerCrash
} from "lucide-react";

import "./TikpagBI.css";

function TikpagBI() {
  const [status, setStatus] = useState(null);
  const [resultado, setResultado] = useState(null);
  const [mensagem, setMensagem] = useState("");
  const [loadingStatus, setLoadingStatus] = useState(false);
  const [loadingSync, setLoadingSync] = useState(false);

  const [rankingVolume, setRankingVolume] = useState([]);
  const [rankingTicketAlto, setRankingTicketAlto] = useState([]);
  const [rankingTicketBaixo, setRankingTicketBaixo] = useState([]);
  const [loadingRanking, setLoadingRanking] = useState(false);

  const [comparativo, setComparativo] = useState(null);
  const [loadingComparativo, setLoadingComparativo] = useState(false);

  const carregarStatus = async () => {
    setLoadingStatus(true);
    setMensagem("");

    try {
      const { data } = await axios.get("/admin/tikpag-bi/status");
      setStatus(data);
    } catch (err) {
      setMensagem(
        err.response?.data?.error ||
          "Não foi possível carregar o status do BI."
      );
    } finally {
      setLoadingStatus(false);
    }
  };

      const carregarRanking = async () => {
        setLoadingRanking(true);

        try {
          const { data } = await axios.get("/admin/tikpag-bi/ranking");

          setRankingVolume(Array.isArray(data.ranking_volume) ? data.ranking_volume : []);
          setRankingTicketAlto(Array.isArray(data.ranking_ticket_alto) ? data.ranking_ticket_alto : []);
          setRankingTicketBaixo(Array.isArray(data.ranking_ticket_baixo) ? data.ranking_ticket_baixo : []);
        } catch (err) {
          setMensagem(
            err.response?.data?.error ||
              "Não foi possível carregar o ranking de empresas."
          );
        } finally {
          setLoadingRanking(false);
        }
      };

      const carregarComparativo = async () => {
        setLoadingComparativo(true);

        try {
          const { data } = await axios.get("/admin/tikpag-bi/comparativo");
          setComparativo(data);
        } catch (err) {
          setMensagem(
            err.response?.data?.error ||
              "Não foi possível carregar os comparativos do BI."
          );
        } finally {
          setLoadingComparativo(false);
        }
      };


  useEffect(() => {
  carregarStatus();
  carregarRanking();
  carregarComparativo();
}, []);

  const sincronizar = async (paginas) => {
    setLoadingSync(true);
    setMensagem("");
    setResultado(null);

    try {
      const { data } = await axios.post("/admin/tikpag-bi/sincronizar", {
        modo: "incremental",
        paginas
      });

      setResultado(data.resumo);
      setMensagem(data.message || "Sincronização concluída.");
      await carregarStatus();
      await carregarRanking();
      await carregarComparativo();
    } catch (err) {
      setMensagem(
        err.response?.data?.error ||
          "Não foi possível sincronizar os dados da Tikpag."
      );
    } finally {
      setLoadingSync(false);
    }
  };

  

  const formatarData = (valor) => {
    if (!valor) return "-";

    try {
      return new Date(valor).toLocaleString("pt-BR");
    } catch {
      return "-";
    }
  };

  const formatarMoeda = (valor) => {
      return Number(valor || 0).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL"
      });
    };

    const formatarNumero = (valor) => {
      return Number(valor || 0).toLocaleString("pt-BR");
    };

    const formatarPercentual = (valor) => {
    const numero = Number(valor || 0);

    return `${numero > 0 ? "+" : ""}${numero.toLocaleString("pt-BR", {
      minimumFractionDigits: 1,
      maximumFractionDigits: 1
    })}%`;
  };

    const renderTabelaRanking = (lista, tituloVazio = "Nenhuma empresa encontrada.") => (
  <div className="tikpagBI-tableWrap tikpagBI-tableScroll">
    <table className="tikpagBI-table tikpagBI-rankingTable">
      <thead>
        <tr>
          <th>#</th>
          <th>Empresa</th>
          <th>CNPJ</th>
          <th>Operações</th>
          <th>Volume aprovado</th>
          <th>Ticket médio</th>
          <th>Última operação</th>
          <th>Ações</th>
        </tr>
      </thead>

      <tbody>
        {lista.map((item, index) => (
          <tr key={`${item.imobiliaria_cnpj}-${index}`}>
            <td>
              <span className="tikpagBI-rankBadge">{index + 1}</span>
            </td>

            <td>
              <strong>{item.imobiliaria || "Sem nome"}</strong>
            </td>

            <td>{item.imobiliaria_cnpj || "-"}</td>
            <td>{formatarNumero(item.qtd_operacoes)}</td>

            <td>
              <strong>{formatarMoeda(item.valor_total)}</strong>
            </td>

            <td>{formatarMoeda(item.ticket_medio)}</td>
            <td>{formatarData(item.ultima_operacao)}</td>

            <td>
              <Link
                to={`/admin/tikpag-bi/imobiliaria/${item.imobiliaria_cnpj}`}
                className="tikpagBI-detailButton"
              >
                Ver detalhes
              </Link>
            </td>

          </tr>
        ))}

        {!lista.length && (
          <tr>
            <td colSpan="7">{tituloVazio}</td>
          </tr>
        )}
      </tbody>
    </table>
  </div>
);

  return (
    <div className="tikpagBI-page">
      <header className="tikpagBI-header">
        <div>
          <span className="tikpagBI-kicker">BI Tikpag</span>
          <h1>Sincronização de Operações</h1>
          <p>
            Acompanhe o snapshot local das operações da Tikpag e atualize os
            dados recentes usados nos painéis de performance das empresas.
          </p>
        </div>

        <button
          type="button"
          onClick={carregarStatus}
          disabled={loadingStatus}
          className="tikpagBI-refresh"
        >
          <RefreshCcw
            size={16}
            className={loadingStatus ? "tikpagBI-spin" : ""}
          />
          Atualizar status
        </button>
      </header>

      {mensagem && (
        <div className="tikpagBI-alert">
          <CheckCircle2 size={18} />
          <span>{mensagem}</span>
        </div>
      )}

      <section className="tikpagBI-cards">
        <div className="tikpagBI-card">
          <div className="tikpagBI-cardIcon">
            <Database size={22} />
          </div>

          <span>Total local</span>
          <strong>{status?.geral?.total_local || 0}</strong>
          <small>operações sincronizadas</small>
        </div>

        <div className="tikpagBI-card">
          <div className="tikpagBI-cardIcon">
            <Activity size={22} />
          </div>

          <span>Primeira operação</span>
          <strong>{formatarData(status?.geral?.primeira_operacao)}</strong>
          <small>menor data no snapshot</small>
        </div>

        <div className="tikpagBI-card">
          <div className="tikpagBI-cardIcon">
            <Activity size={22} />
          </div>

          <span>Última operação</span>
          <strong>{formatarData(status?.geral?.ultima_operacao)}</strong>
          <small>maior data no snapshot</small>
        </div>

        <div className="tikpagBI-card">
          <div className="tikpagBI-cardIcon">
            <RefreshCcw size={22} />
          </div>

          <span>Última sincronização</span>
          <strong>{formatarData(status?.geral?.ultima_sincronizacao)}</strong>
          <small>último update local</small>
        </div>
      </section>

      <section className="tikpagBI-cardLarge">
        <div className="tikpagBI-sectionHeader">
          <div>
            <h2>Sincronizar dados recentes</h2>
            <p>
              Use sincronizações pequenas durante o expediente. Para carga
              histórica completa, rode em lotes fora do horário de maior uso.
            </p>
          </div>
        </div>

        <div className="tikpagBI-actions">
          <button
            type="button"
            onClick={() => sincronizar(3)}
            disabled={loadingSync}
          >
            <RefreshCcw size={16} className={loadingSync ? "tikpagBI-spin" : ""} />
            Últimas 3 páginas
          </button>

          <button
            type="button"
            onClick={() => sincronizar(20)}
            disabled={loadingSync}
          >
            <RefreshCcw size={16} className={loadingSync ? "tikpagBI-spin" : ""} />
            Últimas 20 páginas
          </button>

          <button
            type="button"
            onClick={() => sincronizar(50)}
            disabled={loadingSync}
          >
            <RefreshCcw size={16} className={loadingSync ? "tikpagBI-spin" : ""} />
            Últimas 50 páginas
          </button>
        </div>

        {resultado && (
          <div className="tikpagBI-result">
            <h3>Resultado da última sincronização</h3>

            <div className="tikpagBI-resultGrid">
              <div>
                <span>Modo</span>
                <strong>{resultado.modo}</strong>
              </div>

              <div>
                <span>Total API</span>
                <strong>{resultado.total_api}</strong>
              </div>

              <div>
                <span>Última página</span>
                <strong>{resultado.ultima_pagina}</strong>
              </div>

              <div>
                <span>Páginas processadas</span>
                <strong>{resultado.paginas_processadas}</strong>
              </div>

              <div>
                <span>Recebidos</span>
                <strong>{resultado.registros_recebidos}</strong>
              </div>

              <div>
                <span>Salvos</span>
                <strong>{resultado.registros_salvos}</strong>
              </div>
            </div>

            {resultado.erros?.length > 0 && (
              <div className="tikpagBI-errorBox">
                <ServerCrash size={17} />
                {resultado.erros.length} erro(s) durante a sincronização.
              </div>
            )}
          </div>
        )}
      </section>

      <section className="tikpagBI-cardLarge">
        <div className="tikpagBI-sectionHeader">
          <div>
            <h2>Resumo por status</h2>
            <p>Distribuição das operações já gravadas no snapshot local.</p>
          </div>
        </div>

        <div className="tikpagBI-tableWrap">
          <table className="tikpagBI-table">
            <thead>
              <tr>
                <th>Status</th>
                <th>Total</th>
              </tr>
            </thead>

            <tbody>
              {(status?.por_status || []).map((item) => (
                <tr key={item.status || "sem-status"}>
                  <td>
                    <strong>{item.status || "Sem status"}</strong>
                  </td>
                  <td>{item.total}</td>
                </tr>
              ))}

              {!status?.por_status?.length && (
                <tr>
                  <td colSpan="2">Nenhum dado sincronizado ainda.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>

      <section className="tikpagBI-alertCards">
        <div className="tikpagBI-alertCard destaque">
          <span>Volume aprovado 30 dias</span>
          <strong>{formatarMoeda(comparativo?.cards?.volume_30d)}</strong>
          <small>
            {formatarPercentual(comparativo?.cards?.variacao_volume_percentual)} vs 30 dias anteriores
          </small>
        </div>

        <div className="tikpagBI-alertCard">
          <span>Operações aprovadas</span>
          <strong>{formatarNumero(comparativo?.cards?.operacoes_30d)}</strong>
          <small>Últimos 30 dias</small>
        </div>

        <div className="tikpagBI-alertCard">
          <span>Ticket médio</span>
          <strong>{formatarMoeda(comparativo?.cards?.ticket_30d)}</strong>
          <small>Baseado em aprovadas</small>
        </div>

        <div className="tikpagBI-alertCard risco">
          <span>Taxa de aprovação</span>
          <strong>{formatarPercentual(comparativo?.cards?.taxa_aprovacao_30d)}</strong>
          <small>
            {formatarNumero(comparativo?.cards?.negadas_30d)} negadas nos últimos 30 dias
          </small>
        </div>
      </section>

      <section className="tikpagBI-insightGrid">
        <div className="tikpagBI-cardLarge">
          <div className="tikpagBI-sectionHeader tikpagBI-sectionHeaderRow">
            <div>
              <h2>Empresas em crescimento</h2>
              <p>
                Comparativo dos últimos 30 dias contra os 30 dias anteriores.
              </p>
            </div>

            <Link
              to="/admin/tikpag-bi/crescimento"
              className="tikpagBI-smallButton"
            >
              Ver análise completa
            </Link>
          </div>

          <div className="tikpagBI-tableWrap tikpagBI-tableScroll">
            <table className="tikpagBI-table">
              <thead>
                <tr>
                  <th>Empresa</th>
                  <th>Atual</th>
                  <th>Anterior</th>
                  <th>Variação</th>
                  <th>Ações</th>
                </tr>
              </thead>

              <tbody>
                {(comparativo?.crescimento || []).map((item) => (
                  <tr key={item.imobiliaria_cnpj}>
                    <td><strong>{item.imobiliaria}</strong></td>
                    <td>{formatarMoeda(item.volume_atual)}</td>
                    <td>{formatarMoeda(item.volume_anterior)}</td>
                    <td>
                      <span className="tikpagBI-var positiva">
                        {formatarPercentual(item.variacao_percentual)}
                      </span>
                    </td>
                    <td>
                    <Link
                      to={`/admin/tikpag-bi/imobiliaria/${item.imobiliaria_cnpj}`}
                      className="tikpagBI-detailButton"
                    >
                      Ver empresa
                    </Link>
                  </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className="tikpagBI-cardLarge">
          <div className="tikpagBI-sectionHeader tikpagBI-sectionHeaderRow">
              <div>
                <h2>Empresas em queda</h2>
                <p>
                  Comparativo dos últimos 30 dias contra os 30 dias anteriores.
                </p>
              </div>

              <Link
                to="/admin/tikpag-bi/queda"
                className="tikpagBI-smallButton"
              >
                Ver análise completa
              </Link>
            </div>

          <div className="tikpagBI-tableWrap tikpagBI-tableScroll">
            <table className="tikpagBI-table">
              <thead>
                <tr>
                <th>Empresa</th>
                <th>Atual</th>
                <th>Anterior</th>
                <th>Variação</th>
                <th>Ações</th>
              </tr>
              </thead>

              <tbody>
                {(comparativo?.queda || []).map((item) => (
                  <tr key={item.imobiliaria_cnpj}>
                    <td><strong>{item.imobiliaria}</strong></td>
                    <td>{formatarMoeda(item.volume_atual)}</td>
                    <td>{formatarMoeda(item.volume_anterior)}</td>
                    <td>
                      <span className="tikpagBI-var negativa">
                        {formatarPercentual(item.variacao_percentual)}
                      </span>
                    </td>
                    <td>
                      <Link
                        to={`/admin/tikpag-bi/imobiliaria/${item.imobiliaria_cnpj}`}
                        className="tikpagBI-detailButton"
                      >
                        Ver empresa
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="tikpagBI-cardLarge">
        <div className="tikpagBI-sectionHeader tikpagBI-sectionHeaderRow">
          <div>
            <h2>Alertas de empresas sem movimento</h2>
            <p>Empresas com 7 dias ou mais sem nova operação registrada.</p>
          </div>

          <button
            type="button"
            onClick={carregarComparativo}
            disabled={loadingComparativo}
            className="tikpagBI-smallButton"
          >
            <RefreshCcw
              size={15}
              className={loadingComparativo ? "tikpagBI-spin" : ""}
            />
            Atualizar alertas
          </button>
        </div>

        <div className="tikpagBI-tableWrap tikpagBI-tableScroll">
          <table className="tikpagBI-table">
            <thead>
              <tr>
                <th>Empresa</th>
                <th>CNPJ</th>
                <th>Última operação</th>
                <th>Dias sem operação</th>
                <th>Volume histórico</th>
              </tr>
            </thead>

            <tbody>
              {(comparativo?.sem_movimento || []).map((item) => (
                <tr key={item.imobiliaria_cnpj}>
                  <td><strong>{item.imobiliaria}</strong></td>
                  <td>{item.imobiliaria_cnpj}</td>
                  <td>{formatarData(item.ultima_operacao)}</td>
                  <td>
                    <span className="tikpagBI-alertBadge">
                      {item.dias_sem_operacao} dias
                    </span>
                  </td>
                  <td>{formatarMoeda(item.volume_aprovado_historico)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>

      <section className="tikpagBI-cardLarge">
  <div className="tikpagBI-sectionHeader tikpagBI-sectionHeaderRow">
    <div>
      <h2>Ranking por volume aprovado</h2>
      <p>Empresas com maior volume financeiro aprovado no snapshot local.</p>
    </div>

    <button
      type="button"
      onClick={carregarRanking}
      disabled={loadingRanking}
      className="tikpagBI-smallButton"
    >
      <RefreshCcw
        size={15}
        className={loadingRanking ? "tikpagBI-spin" : ""}
      />
      Atualizar ranking
    </button>
  </div>

  {renderTabelaRanking(rankingVolume)}
</section>

<section className="tikpagBI-cardLarge">
  <div className="tikpagBI-sectionHeader">
    <div>
      <h2>Maior ticket médio</h2>
      <p>Empresas com maior ticket médio aprovado, considerando no mínimo 3 operações.</p>
    </div>
  </div>

  {renderTabelaRanking(rankingTicketAlto)}
</section>

<section className="tikpagBI-cardLarge">
  <div className="tikpagBI-sectionHeader">
    <div>
      <h2>Menor ticket médio</h2>
      <p>Empresas com menor ticket médio aprovado, considerando no mínimo 3 operações.</p>
    </div>
  </div>

  {renderTabelaRanking(rankingTicketBaixo)}
</section>

    </div>
  );
}

export default TikpagBI;